var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"extra-style-page"},[_c('img',{attrs:{"src":require("../../../assets/images/extra-style/header.jpg")}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }